__turbopack_context__.v({
  "infoParagraph": "P_t-RW_infoParagraph",
  "infoParagraphs": "P_t-RW_infoParagraphs",
  "participantsList": "P_t-RW_participantsList",
});
